import styled from '@emotion/styled'
import { WebLink } from '@news-mono/web-common'
import { breakpoint, calcRem, fonts } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'
const { uplate, white } = tokens.thenightly.colors.palette
import { TheNightlyHorizontalLogo } from '../../logos/TheNightlyLogo/TheNightlyHorizontalLogo'

export const StyledTNPromoBannerContainer = styled.div(({ theme }) => ({
    clear: 'both',
    borderTop: `1px solid ${theme.colors.borders.primary}`,
    borderBottom: `1px solid ${theme.colors.borders.primary}`,
    marginBottom: calcRem(40),
    padding: calcRem(24, 0),
    display: 'flex',
    gap: calcRem(24),
    flexDirection: 'column',

    [breakpoint('xs')]: {
        padding: calcRem(48, 0),
    },
}))

export const StyledHeading = styled.h2(() => ({
    fontFamily: fonts.thenightly.sansSerif,
    fontSize: calcRem(32),
    fontWeight: 600,
    lineHeight: calcRem(40),
    letterSpacing: '-1.6px',
    color: tokens.thenightly.colors.text.primary,
    margin: 0,

    [breakpoint('xs')]: {
        fontSize: calcRem(40),
        lineHeight: calcRem(48),
    },
}))

export const StyledTextContainer = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(24),

    '& p': {
        fontFamily: fonts.thenightly.serif,
        fontSize: calcRem(22),
        color: tokens.thenightly.colors.text.tertiary,
        margin: 0,

        [breakpoint('xs')]: {
            maxWidth: '75%',
            fontSize: calcRem(24),
        },
    },

    [breakpoint('xs')]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}))

export const StyledButton = styled(WebLink)(() => ({
    background: uplate.default,
    color: white,
    textDecoration: 'unset',
    display: 'grid',
    placeItems: 'center',
    padding: calcRem(12, 24),
    borderRadius: calcRem(8),
    fontFamily: fonts.thenightly.sansSerif,
    fontSize: calcRem(16),
    fontWeight: 600,
    lineHeight: calcRem(24),
    textTransform: 'uppercase',
    textWrap: 'nowrap',

    '&:hover': {
        opacity: 0.8,
    },
    transition: 'opacity 0.25s',
}))

export const StyledTheNightlyLogo = styled(TheNightlyHorizontalLogo)({
    display: 'block',
})
